"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zh_CN = _interopRequireDefault(require("ant-design-vue/lib/locale-provider/zh_CN"));
var _providerApi = require("./config/providerApi");
var _default = exports.default = {
  name: 'App',
  data() {
    return {
      locale: _zh_CN.default,
      providerApi: _providerApi.providerApi,
      searchForm: {
        controlsPerRow: {
          xs: 2,
          sm: 3,
          md: 3,
          lg: 4,
          xl: 5
        }
      }
    };
  },
  created() {
    window.addEventListener('resize', e => {
      this.$store.commit('SET_SCREEN_INFO', {
        clientWidth: e.target.innerWidth,
        clientHeight: e.target.innerHeight
      });
    });
  },
  methods: {
    getPopupContainer(el, dialogContext) {
      if (dialogContext) {
        return dialogContext.getDialogWrap();
      }
      return el?.parentNode || document.body;
    }
  }
};